import React from 'react'

export default function UserProfileImageLoader() {
    return (
        <div className="lds-spinner text-dark"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    )
}
